import React from 'react'
import ReactPlaceholder from "react-placeholder";
import { Placeholder } from 'semantic-ui-react'

export function CustomPlaceholder() {
    return (
        <div id="images" className="imageHolder" style={{ display: 'flex', justifyContent: 'center' }}>
            <h3>Loading Media...</h3>
        </div>
    )
}

export function PlaceholderExampleImage() {
    return (
        <Placeholder style={{ height: 150, width: 150 }}>
            <Placeholder.Image />
        </Placeholder>
    )
}

export default function Image({ src }) {

    const [state, setState] = React.useState({
        loaded: false
    })

    function handleImageLoaded() {
        setState({ ...state, loaded: true });
    }

    const { loaded } = state;
    const imageStyle = !loaded ? { display: "none" } : {};
    const image = <img src={src} draggable="false" style={imageStyle} onLoad={() => handleImageLoaded()} />;
    return (
        <>
            <ReactPlaceholder showLoadingAnimation={true} customPlaceholder={<CustomPlaceholder/>} type="rect" color='#605E56' ready={loaded} style={{ width: 500, height: 500 }} >
                <div id="images" className="imageHolder">
                    {image}
                </div>
            </ReactPlaceholder>
            {!loaded && image
                // :
                // <Placeholder style={{ height: 150, width: 150 }}>
                //     <Placeholder.Image />
                // </Placeholder>
            }
        </>
    )
}